<template>
  <main>
    <!-- Shared SVG paint server for the heart icon. Defined once here (rather than per Heart
         instance) so the page never holds duplicate `#hearty` ids: duplicates make mobile
         WebKit drop the `fill: url(#hearty)` reference on reflow, blanking a heart. -->
    <svg width="0" height="0" aria-hidden="true" style="position: absolute">
      <linearGradient id="hearty" x1="100%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" style="stop-color:#E11D48;stop-opacity:1"/>
        <stop offset="100%" style="stop-color:#FB7185;stop-opacity:1"/>
      </linearGradient>
    </svg>
    <RouterView />
    <AchievementToast />
  </main>
</template>

<script setup>
import AchievementToast from "./components/AchievementToast.vue";
</script>
